import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextMedium from "../TextComponent/TextMedium";
import { ResponsiveRadialBar } from "@nivo/radial-bar";
import moment, { diff } from "moment";

import Typography from "../../Typography";
import TimeCounterInternal from "../../../containers/TimeCounterInternalDash";
import TimeCounterMinute from "../../../containers/TimeCounterMinute";
import { connection_platform } from "../../../services/api";

import { ReactComponent as TimeIcon } from "../../../build/images/icontime.svg";
import { ReactComponent as MicrophoneIcon } from "../../../build/images/microphone-2.svg";
import { ReactComponent as MessagesIcon } from "../../../build/images/messages.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";

export default function CardTimeRow({ type, typeRow }) {
  const listCallQueue = useSelector((state) => state.listcallqueue);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const groupsRow = useSelector((state) => state.groupsrow);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const InfoUsers = useSelector((state) => state.informationusers);

  const [voiceTotal, setVoiceTotal] = useState(0);
  const [digitalTotal, setDigitalTotal] = useState(0);
  const [tempoMedio, setTempoMedio] = useState("00:00:00");
  const [tempoMaximo, setTempoMaximo] = useState("00:00:00");
  const [diasCalc, setDiasCalc] = useState({ diasMedio: 0, diasMaximo: 0 });

  let showTime = "";

  const data1 = [
    {
      id: "Voz",
      data: [
        {
          x: "Fila Voz",
          // y: (95 * 100) / 100,
          y: 40,
          color: "#008908",
          colorTrack: "rgba(0, 137, 8, 0.20)",
        },
      ],
    },
  ];

  const data2 = [
    {
      id: "Digital",
      data: [
        {
          x: "Fila Digital",
          // y: (95 * 100) / 100,
          y: 40,
          color: "#1E88E5",
          colorTrack: "rgba(30, 136, 229, 0.20)",
        },
      ],
    },
  ];

  const CenteredMetric = ({ center, bars }) => {
    const ref = useRef(null);
    if (bars.length) {
      return (
        <text
          x={center[0]}
          y={center[1]}
          style={{
            fontSize: 20,
            fontFamily: "Inter",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "28px",
            fill: `${bars[0].color}`,
          }}
          textAnchor="middle"
          dominantBaseline="central"
          ref={ref}
        >
          {`${bars[0].value}%`}
        </text>
      );
    }

    return null;
  };

  const calcMediaTime = (data) => {
    const datas = [moment(), ...data];

    let somaDiferencasSegundos = 0;

    for (let i = 0; i < datas.length - 1; i++) {
      for (let j = i + 1; j < datas.length; j++) {
        const diferencaEmSegundos = Math.abs(
          datas[j].diff(datas[i], "seconds")
        );
        somaDiferencasSegundos += diferencaEmSegundos;
      }
    }

    const numeroTotalDePares = (datas.length * (datas.length - 1)) / 2;

    const tempoMedioSegundos = somaDiferencasSegundos / numeroTotalDePares;

    const horas = Math.floor(tempoMedioSegundos / 3600);
    const minutos = Math.floor((tempoMedioSegundos % 3600) / 60);
    const segundos = Math.floor(tempoMedioSegundos % 60);

    const tempoMedioFormatado = moment()
      .startOf("day")
      .add(horas, "hours")
      .add(minutos, "minutes")
      .add(segundos, "seconds")
      .format("HH:mm:ss");

    // return tempoMedioFormatado;
    return segundos;
  };

  const calculateTime = (date) => {
    let duracao = 0;
    let arrayCompA = date;
    let datatimeCompA = moment().format("YYYY/MM/DD HH:mm:ss");
    let dataStatusA = moment(arrayCompA, "DD/MM/YYYY HH:mm:ss").format(
      "YYYY/MM/DD HH:mm:ss"
    );

    var valorDiferenca = parseInt(
      Math.abs(Math.round(LoginCompleteReducer.difftime))
    );

    if (parseInt(LoginCompleteReducer.difftime) < 0) {
      datatimeCompA = moment()
        .subtract(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    } else {
      datatimeCompA = moment()
        .add(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }

    duracao = moment(datatimeCompA).diff(dataStatusA, "seconds");
    duracao = duracao < 0 ? 0 : duracao;
    return duracao;
  };

  const convertDays = (totalSeconds) => {
    const secondsInDay = 86400;
    const days = Math.floor(totalSeconds / secondsInDay);

    return days;
  };

  useEffect(() => {
    if (FiltersManager.is_active) {
      let beforeIsFilter = groupsRow;

      beforeIsFilter = beforeIsFilter.filter((filter) =>
        FiltersManager.filter_manager_grouprow.includes(filter.idgrupofila)
      );

      let listCall = [];

      for (const group of beforeIsFilter) {
        let subServices = JSON.parse(group.idsubservico);
        let servicesChange = subServices.map((sub) => sub.id_resposta);

        listCall.push(...servicesChange);
      }

      let listRowQueue = listCallQueue.filter(
        (call) => parseInt(call.status) === 1
      );

      const listQueue = listRowQueue.filter((call) =>
        listCall.includes(call.serviceinid)
      );

      if (listQueue.length) {
        if (type === "row") {
          if (typeRow === "Voz") {
            const findVoice = listQueue.filter((queue) => queue.mediaid === 1);
            setVoiceTotal(findVoice.length);
          } else {
            const findDigital = listQueue.filter(
              (queue) => queue.mediaid !== 1
            );
            setDigitalTotal(findDigital.length);
          }
        } else {
          if (typeRow === "Voz") {
            const findVoice = listQueue.filter((queue) => queue.mediaid === 1);
            if (findVoice.length) {
              let higherTemp = "";
              const timeAll = findVoice.map((msg) => {
                // calculateTime(msg.to_char);
                const timeCatch = calculateTime(msg.to_char);
                if (timeCatch > higherTemp) {
                  higherTemp = timeCatch;
                }

                return timeCatch;
              });
              const tempo = timeAll.reduce((a, b) => a + b) / findVoice.length;
              const dias = convertDays(tempo);
              setDiasCalc({ ...diasCalc, diasMedio: dias });
              setTempoMedio(tempo);

              if (higherTemp) {
                setTempoMaximo(higherTemp);
                const diasMax = convertDays(higherTemp);
                setDiasCalc({ ...diasCalc, diasMaximo: diasMax });
              }
            } else {
              setTempoMedio("00:00:00");
              setTempoMaximo("00:00:00");
              setDiasCalc({ diasMedio: 0, diasMaximo: 0 });
            }
          } else {
            const findDigital = listQueue.filter(
              (queue) => queue.mediaid !== 1
            );

            if (findDigital.length) {
              let higherTemp = "";
              const timeAll = findDigital.map((msg) => {
                // calculateTime(msg.to_char)
                const timeCatch = calculateTime(msg.to_char);
                if (timeCatch > higherTemp) {
                  higherTemp = timeCatch;
                }

                return timeCatch;
              });
              const tempo =
                timeAll.reduce((a, b) => a + b) / findDigital.length;
              setTempoMedio(tempo);
              const dias = convertDays(tempo);
              setDiasCalc({ ...diasCalc, diasMedio: dias });
              if (higherTemp) {
                setTempoMaximo(higherTemp);
                const diasMax = convertDays(higherTemp);
                setDiasCalc({ ...diasCalc, diasMaximo: diasMax });
              }
            } else {
              setTempoMedio("00:00:00");
              setTempoMaximo("00:00:00");
              setDiasCalc({ diasMedio: 0, diasMaximo: 0 });
            }
          }
        }
      } else {
        if (type === "row") {
          if (typeRow === "Voz") {
            setVoiceTotal(listQueue.length);
          } else {
            setDigitalTotal(listQueue.length);
          }
        } else {
          setTempoMedio("00:00:00");
          setTempoMaximo("00:00:00");
          setDiasCalc({ diasMedio: 0, diasMaximo: 0 });
        }
      }
    }
  }, [listCallQueue, FiltersManager, groupsRow]);

  return (
    <>
      {type === "row" && (
        <div className={`manager-component__card-queue time-row`}>
          <Typography.H6 color={"gray-180"}>Fila {typeRow}</Typography.H6>
          <div className="time-value">
            {typeRow === "Voz" ? <MicrophoneIcon /> : <MessagesIcon />}
            <Typography.H1 weight={700} color={"gray-600"}>
              {typeRow === "Voz" ? voiceTotal : digitalTotal}
            </Typography.H1>
          </div>
        </div>
      )}
      {type !== "row" && connection_platform.showTimeMedDashboard && (
        <div className={`manager-component__card-queue `}>
          <div className="title-time">
            <Typography.H6 color={"gray-180"}>
              Tempo Med. de espera {typeRow}
            </Typography.H6>
          </div>
          <div className="time-value">
            <TimeIcon />
            {tempoMedio !== "00:00:00" ? (
              <Typography.H1 weight={700} color={"gray-600"}>
                {/* <TimeCounterInternal
                  horario={parseInt(tempoMedio)}
                  iduser={2410}
                  key={tempoMedio}
                /> */}
                <TimeCounterMinute
                  horario={parseInt(tempoMedio)}
                  iduser={2410}
                  key={tempoMedio}
                  day={diasCalc.diasMedio}
                />
              </Typography.H1>
            ) : (
              <Typography.H1 weight={700} color={"gray-600"}>
                {tempoMedio}
              </Typography.H1>
            )}
          </div>
        </div>
      )}
      {type !== "row" && (
        <div className={`manager-component__card-queue `}>
          <>
            <div className="title-time">
              <Typography.H6 color={"gray-180"}>
                Maior Tempo de espera {typeRow}
              </Typography.H6>
            </div>
            <div className="time-value">
              <TimeIcon />
              {tempoMaximo !== "00:00:00" ? (
                <Typography.H1 weight={700} color={"gray-600"}>
                  {/* <TimeCounterInternal
                    horario={parseInt(tempoMaximo)}
                    iduser={2411}
                    key={tempoMaximo}
                    maxTime={InfoUsers.tmsdashboard.maxtimerow}
                  /> */}
                  <TimeCounterMinute
                    horario={parseInt(tempoMaximo)}
                    iduser={2411}
                    key={tempoMaximo}
                    maxTime={InfoUsers.tmsdashboard.maxtimerow}
                    day={diasCalc.diasMaximo}
                  />
                </Typography.H1>
              ) : (
                <Typography.H1 weight={700} color={"gray-600"}>
                  {tempoMaximo}
                </Typography.H1>
              )}
            </div>
          </>
        </div>
      )}
    </>
  );
}
